<script lang="ts">
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let icon: UIcons;
    export let title: string;
    export let description: string;
</script>

<div class="icon-info-block-banner">
    <div class="icon-container">
        <UIcon icon={icon}/>
    </div>

    <h1 class="banner-title">{title}</h1>

    <span class="label-text text-muted text-center">{description}</span>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .icon-info-block-banner {
        width: 100%;
        background-color: @themed-body-bg-blue-highlighted;
        color: var(--accent-blue-new);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-radius: @border-radius-large;
        padding: 2em 3em;

        .icon-container {
            margin-bottom: @spacing-m;
            font-size: @font-size-large;
        }

        .banner-title {
            margin-top: 0;
            margin-bottom: 14px;
            color: var(--accent-blue-new);
            font-size: @font-size-large;
            font-weight: 500;
        }

        .label-text {
            max-width: 600px;
        }
    }
</style>